import React from 'react'
import PropTypes from 'prop-types'
import Shimmer from 'Components/shimmer'

const MaleDailyArticleCardFourShimmer = ({ isMobile }) => {
  const device = isMobile ? 'mobile' : 'desktop'
  return (
    <>
      <div
        className={`article-style-four-shimmer article-style-four-shimmer--${device}`}
      >
        <div className="article-style-four-shimmer__divider" />
        <div className="article-style-four-shimmer__text">
          <Shimmer width="88px" height="12px" />
          <div className="article-style-four-shimmer__title">
            <Shimmer width="100%" height="12px" />
            <Shimmer width="100%" height="12px" />
          </div>
        </div>
      </div>
      <style jsx>
        {`
          .article-style-four-shimmer {
            display: flex;
            flex-direction: column;
            gap: 20px;
            text-decoration: none;
          }

          .article-style-four-shimmer--mobile {
            grid-template-columns: 156px 1fr;
          }

          .article-style-four-shimmer__divider {
            border-top: 1px solid var(--border-default);
            width: 100%;
          }

          .article-style-four-shimmer__text {
            display: flex;
            flex-direction: column;
            gap: 8px;
          }

          .article-style-four-shimmer__image--mobile {
            width: 156px;
            height: auto;
          }
        `}
      </style>
    </>
  )
}

MaleDailyArticleCardFourShimmer.propTypes = {
  isMobile: PropTypes.bool,
}

export default MaleDailyArticleCardFourShimmer
